/**
 * Fonts
 */

export const standardFontFamily =
	'"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif'
export const headingFontFamily = '"Telegraphem", "Helvetica Neue", Helvetica, Arial, sans-serif'
export const weightSemiBold = 600
export const weightRegular = 400
export const weightMedium = 500
export const headingLetterSpacing = '0.2em'
